export enum AuthFormFields {
  IdentificationType = 'identificationType',
  IdDocument = 'idDocument',
  Name = 'name',
  Email = 'email',
  Phone = 'phone',
  LandlinePhone = 'landlinePhone'
}
